import { DefaultService } from '@/services/DefaultService';

export default class CidadeService extends DefaultService {

    constructor(http, router, env) {
        super(http, router, env)
    }

    save(cidade) {
        return this._http.post(`${this._env}/general/city`, cidade, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    find(id) {
        return this._http.get(`${this._env}/general/city/${id}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    findAll(page = 0, limit = 50, ...param) {
        return this._http.get(encodeURI(`${this._env}/general/city.json?page=${page}&limit=${limit}&param=${param}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    findAllCombo(...param) {
        return this._http.get(encodeURI(`${this._env}/general/getcombo/city.json?param=${param}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    findByEstado(page, limit, idestado) {
        return this._http.get(`${this._env}/general/state-city.json?page=${page}&limit=${limit}&idestado=${idestado}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

}